"use client";

import { forwardRef, ReactNode } from "react";
import { cn } from "@drpcrd/utils/shared";

export type DialogListProps = {
  children: ReactNode;
  className?: string;
  ariaLabel?: string;
};

/**
 * A listbox wrapper component for DialogListItem components with proper ARIA semantics
 */
export const DialogList = forwardRef<HTMLDivElement, DialogListProps>(
  ({ children, className, ariaLabel = "Options" }, ref) => (
    <div
      ref={ref}
      role="listbox"
      aria-label={ariaLabel}
      className={cn("divide-border-primary divide-y", className)}
    >
      {children}
    </div>
  ),
);
DialogList.displayName = "DialogList";
